module.exports = __webpack_public_path__ + "img/icon-avito.a5bd415f.svg";